module.exports = __webpack_public_path__ + "static/media/anc2ru.ac33a8ae.pdf";